import jwtDecode from "jwt-decode";

export const isTokenValid = (token: string) => {
   if (token) {
      const decodedToken: any = jwtDecode(token);
      return Date.now() <= decodedToken?.exp * 1000;
   }
   return false;
};
